import React, {
  useState,
  useMemo,
  useCallback,
  useEffect,
  useRef,
} from "react";
import { darken, lighten } from "polished";
import Sidebar from "../../components/sideBar/sideBar.js";
import Navbar from "../../components/navbar/navbar.js";
import gridSideBar from "../../components/GridSideBar/gridSideBar.js";
import createColumnDefs from "./columnDefs.js";
import localStorage from "local-storage";
import SearchIcon from "@mui/icons-material/Search";
import LowPriorityIcon from "@mui/icons-material/LowPriority";
import ExposureIcon from "@mui/icons-material/Exposure";
import {
  Grid,
  Typography,
  Pagination,
  TextField,
  MenuItem,
  Button,
  Autocomplete,
} from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import localeTextTr from "../../locale.tr.js";
import Swal from "sweetalert2";
import { cleanupLocalStorage } from "../../utils/localStorage/cleanupLocalStorage.js";
import { createTurkishFilterParams } from "../../utils/agGridTextFilterTr/agGridFilterUtils.js";
import { getNotes } from "../../api/notesApis/getNotes.js";
import { deleteNote } from "../../api/notesApis/deleteNote.js";
import moment from "moment";
import { getControls } from "../../api/controlsApis/getControls.js";
import { getTaxPayerList } from "../../api/taxPayer/getTaxPayerList/index.js";
import { getTaxTypes } from "../../api/taxTypes/getList/index.js";
import { upsertControls } from "../../api/controlsApis/upsertControls.js";
import { Save } from "@mui/icons-material";
import AddOrRemoveTaxModal from "./addRemoveTaxModal.js";
import RemoveTaxModal from "../AccrualsPage/RemoveTaxModal.js";
import { showLoadingSwal } from "../../components/loadingSwal/index.js";
function ControlsPage() {
  const [addOrRemoveTaxModalOpen, setAddOrRemoveTaxModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [rowData, setRowData] = useState([]);
  // const [taxTypes, setTaxTypes] = useState([]);
  const taxTypesRef = useRef([]);
  const [loading, setLoading] = useState(true);

  const [isOpen, setIsOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [pageSize, setPageSize] = useState(250);
  const [totalCount, setTotalCount] = useState(0);

  const fillDeclarationDetailsFromTaxes = async () => {
    // Swal ile onay sorusu
    const result = await Swal.fire({
      title: "Emin misiniz?",
      text: "Bu buton Tahakkuklar sayfasında mükelleflerinize tanımladığınız vergi türlerini otomatik olarak eklemenizi sağlar. Devam Etmek istiyor musunuz?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Evet",
      cancelButtonText: "Hayır",
      reverseButtons: true,
    });

    // Kullanıcı "Evet" dediyse işlemi gerçekleştir
    if (result.isConfirmed) {
      const updatedRowData = rowData.map((person) => {
        const currentDeclarations = person.declarationDetails || [];
        const personTaxes = person.taxes || [];

        // taxes dizisindeki vergi türlerini taxTypes’ta ara ve declarationDetails’a ekle
        const newTaxesFromPerson = personTaxes
          .map((tax) => {
            const matchedTax = taxTypesRef.current.find(
              (type) => type.value === tax
            );
            if (
              matchedTax &&
              !currentDeclarations.some(
                (detail) => detail.taxTypeId === matchedTax.id
              )
            ) {
              return {
                title: matchedTax.value,
                status: false, // Varsayılan olarak false
                taxTypeId: matchedTax.id,
              };
            }
            return null; // Eşleşme yoksa veya zaten varsa null döndür
          })
          .filter(Boolean);

        // Mevcut declarationDetails + taxes’tan gelenler
        const updatedDeclarationsDetail = [
          ...currentDeclarations,
          ...newTaxesFromPerson,
        ];

        return {
          ...person,
          declarationDetails: updatedDeclarationsDetail,
          month: person.month || selectedMonth,
          year: person.year || selectedYear,
        };
      });
      await handleSave(updatedRowData, undefined, true);
    }
  };

  const handleSave = async (newData, setTaxData, isTempBulk = false) => {
    showLoadingSwal();

    await upsertControls(Array.isArray(newData) ? newData : rowData)
      .then((resp) => {
        Swal.fire("Başarılı!", "Başarıyla Güncellendi.", "success");
        // console.log(resp, "resp");
        search();
        if (Array.isArray(newData) && !isTempBulk) {
          gridApi.deselectAll();
          setAddOrRemoveTaxModalOpen(false);
          setSelectedData([]);
          setTaxData([]);
        }
      })
      .catch((err) => {
        // console.log(err, "err");
        Swal.fire(
          "Hata!",
          "Güncelleme işlemi sırasında bir hata oluştu.",
          "error"
        );
      });
  };

  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1; // 0-11 yerine 1-12
  const currentYear = currentDate.getFullYear();

  // Aylar listesi
  const months = Array.from({ length: 12 }, (_, i) => ({
    id: i + 1,
    label: `${i + 1} - ${new Date(0, i).toLocaleString("tr-TR", {
      month: "long",
    })}`,
  }));

  // Yıllar listesi
  const years = [
    { id: currentYear - 1, label: `${currentYear - 1}` },
    { id: currentYear, label: `${currentYear}` },
    { id: currentYear + 1, label: `${currentYear + 1}` },
  ];
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [selectedYear, setSelectedYear] = useState(currentYear);

  const onSelectionChanged = (event) => {
    const selectedNodes = event.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    setSelectedData(selectedData);
  };
  useEffect(() => {
    const lastPage = localStorage.get("page");
    const lastPageSize = localStorage.get("pageSize");
    const sideBarOpen = localStorage.get("sidebar");

    if (sideBarOpen === "false") {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
    if (lastPage) {
      setCurrentPage(lastPage);
    }
    if (lastPageSize) {
      setPageSize(lastPageSize);
    }
    localStorage.get("scrollPosition");
    // taxTypes'ı al ve sonra search'ü çalıştır
    getTaxTypes()
      .then((resp) => {
        taxTypesRef.current = resp?.data?.data;
        search(); // taxTypes güncellendikten sonra search'ü çağır
      })
      .catch((error) => {
        console.error("Tax types alınırken hata oluştu:", error);
      });

    cleanupLocalStorage();
    window.addEventListener("beforeunload", cleanupLocalStorage);
    return () => {
      window.removeEventListener("beforeunload", cleanupLocalStorage);
    };
  }, []);

  useEffect(() => {
    const lastPage = localStorage.get("page");
    const lastPageSize = localStorage.get("pageSize");
    const sideBarOpen = localStorage.get("sidebar");

    if (sideBarOpen === "false") {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
    if (lastPage) {
      setCurrentPage(lastPage);
    }
    if (lastPageSize) {
      setPageSize(lastPageSize);
    }
    localStorage.get("scrollPosition");
  }, [currentPage, pageSize]);

  useEffect(() => {
    let timer;
    setTimeout(clearLocalStorage, 10 * 60 * 1000);
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [pageSize, currentPage]);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const suppressKeyboardEvent = ({ event }) => {
    return ["ArrowUp", "ArrowDown"].includes(event.key);
  };
  const defaultColDef = useMemo(
    () => ({
      suppressKeyboardEvent: suppressKeyboardEvent,
      defaultExpanded: false,
      enableRangeSelection: true,
      filter: true,
      sortable: true,
      floatingFilter: true,
      filterParams: createTurkishFilterParams(),
    }),
    []
  );
  function clearLocalStorage() {
    localStorage.clear();
  }

  const search = (
    month = moment().month() + 1,
    year = moment().year(),
    searchCurrentPage,
    searchPageSize
  ) => {
    setLoading(true);
    getControls(
      searchPageSize ? searchPageSize : pageSize,
      searchCurrentPage ? searchCurrentPage : currentPage,
      month,
      year
    )
      .then((resp) => {
        // Veriyi AG Grid için dönüştür
        const transformedData = resp?.data?.data.map((taxpayer) => {
          const controls = taxpayer.controls[0] || {}; // İlk controls kaydını al, yoksa boş obje
          return {
            id: taxpayer.id,
            title: taxpayer.title,
            month: controls.month || null,
            year: controls.year || null,
            declarationDetails: controls.declarationDetails || [],
            accountingBook: controls.accountingBook || [],
            number: taxpayer.number,
            mail: taxpayer.mail,
            taxes: taxpayer.taxes || [],
          };
        });

        setColumnDefs(createColumnDefs(month, year, taxTypesRef.current));
        setRowData(transformedData);

        const totalCount = resp?.data?.totalCount; // Şimdilik sadece dönen veri kadar
        const totalPage = resp?.data?.totalPages; // Toplam sayfa sayısı

        setTotalPage(totalPage);
        setTotalCount(totalCount);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        Swal.fire({
          text:
            err?.response?.data?.message || "Veriler alınırken hata oluştu.",
          icon: "error",
          confirmButtonText: "Tamam",
          customClass: {
            container: ".swal-overlay",
          },
        });
      });
  };
  const [columnDefs, setColumnDefs] = useState([]);

  const detailCellRendererParams = useMemo(() => {
    return {
      detailGridOptions: {
        enableRangeSelection: true,

        defaultColDef: {
          flex: 0.5,
          resizable: true,
          floatingFilter: true,
          suppressMenu: false, // Allow menu in detail grid columns
        },
      },
      getDetailRowData: (params) => {
        params.successCallback(params.data.subDetails);
      },
    };
  }, []);
  const [gridApi, setGridApi] = useState(null);
  const onGridReady = useCallback(
    (params) => {
      setGridApi(params.api);
      params.api.resetRowHeights(); // İlk yüklemede sıfırla
    },
    [rowData]
  );
  // rowData değiştiğinde yükseklikleri sıfırla
  useEffect(() => {
    if (gridApi) {
      gridApi.resetRowHeights();
      // Renderer’ın tekrar çalışmasını sağlamak için
      gridApi.redrawRows();
    }
  }, [rowData, gridApi]);
  return (
    <Grid container>
      <Grid
        item
        sx={{
          flexBasis: isOpen ? "275px" : "95px",
          flexShrink: 0,
          transition: "flex-basis 0.3s ease", // Düzeltilmiş transition
        }}
      >
        <Sidebar status={isOpen} toggleSidebar={toggleSidebar} />
      </Grid>

      <Grid
        item
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "flex-end",
          flexDirection: "column",
          gap: 1,
          pr: "12px",
        }}
      >
        <Grid item xs={12}>
          <Navbar />
        </Grid>
        <Grid
          item
          md={12}
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Grid
            className="grid-area"
            sx={{
              mb: 1,
            }}
          >
            <Grid
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                justifyContent: "space-between",
              }}
            >
              <Grid
                item
                xs={5}
                sx={{
                  display: "flex",
                  gap: 1,
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                {/* Ay Seçimi */}
                <Autocomplete
                  value={
                    months.find((month) => month.id === selectedMonth) || null
                  }
                  onChange={(event, newValue) =>
                    setSelectedMonth(newValue?.id || null)
                  }
                  disableClearable
                  options={months}
                  getOptionLabel={(option) => option.label}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Ay Seçin"
                      variant="outlined"
                      size="small"
                    />
                  )}
                  sx={{ width: 200 }}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value?.id
                  }
                />

                {/* Yıl Seçimi */}
                <Autocomplete
                  value={years.find((year) => year.id === selectedYear) || null}
                  onChange={(event, newValue) =>
                    setSelectedYear(newValue?.id || null)
                  }
                  options={years}
                  disableClearable
                  getOptionLabel={(option) => option.label}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Yıl Seçin"
                      variant="outlined"
                      size="small"
                    />
                  )}
                  sx={{ width: 200 }}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value?.id
                  }
                />
                <Button
                  sx={{
                    textTransform: "none",
                    alignItems: "center",
                    gap: 1,
                    marginLeft: "8px",
                    flexGrow: 0,
                    backgroundColor: "#00cfe8",
                    "&:hover": {
                      backgroundColor: darken(0.1, "#00cfe8"),
                      borderColor: "#d9534f",
                    },
                  }}
                  variant="contained"
                  type="submit"
                  onClick={() => {
                    search(selectedMonth, selectedYear, 1, 250);
                  }}
                >
                  <SearchIcon color="white" />
                  Ara
                </Button>
              </Grid>
              <Grid
                item
                xs={7}
                sx={{
                  display: "flex",
                  gap: 1,
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  variant="contained"
                  startIcon={<LowPriorityIcon sx={{ fontSize: "20px" }} />}
                  sx={{
                    textTransform: "none",
                    whiteSpace: "nowrap",
                    flexGrow: 0,
                    minWidth: "auto",
                    width: "auto",
                    backgroundColor: "#8645b1 !important", // Daha canlı bir yeşil
                    borderRadius: "4px",
                    px: 2,
                    "&:hover": {
                      backgroundColor: "#7209b7 !important",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    },
                    transition: "all 0.3s ease",
                  }}
                  onClick={fillDeclarationDetailsFromTaxes}
                >
                  Hazır Kontrol Getir
                </Button>
                <Button
                  sx={{
                    textTransform: "none",
                    alignItems: "center",
                    backgroundColor: "#4361ee", // Daha profesyonel bir mavi
                  }}
                  variant="contained"
                  type="submit"
                  onClick={() => {
                    if (selectedData.length === 0) {
                      Swal.fire(
                        "Uyarı!",
                        "Lütfen en az 1 mükellef seçiniz",
                        "warning"
                      );
                    } else {
                      setAddOrRemoveTaxModalOpen(true);
                    }
                  }}
                  startIcon={
                    <ExposureIcon sx={{ color: "white", fontSize: "20px" }} />
                  }
                >
                  Toplu Kontrol Ekle/Sil
                </Button>

                <Button
                  className="custom-button"
                  variant="contained"
                  startIcon={<Save sx={{ fontSize: "20px" }} />}
                  sx={{
                    textTransform: "none",
                    whiteSpace: "nowrap",
                    flexGrow: 0,
                    minWidth: "auto",
                    width: "auto",
                    backgroundColor: "#0a9f05dd !important",
                    "&:hover": { backgroundColor: "#059800 !important" },
                  }}
                  onClick={handleSave}
                >
                  Kaydet
                </Button>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            className="ag-theme-quartz"
            style={{
              flex: 1,
              minHeight: "70vh",
              maxHeight: "70vh",
              width: "100%",
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
              borderRadius: "10px", // İstediğiniz değeri buraya ekleyin
              overflow: "hidden", // Border-radius'in düzgün görünmesi için
            }}
          >
            <AgGridReact
              localeText={localeTextTr}
              rowSelection="multiple"
              rowData={rowData}
              // getRowHeight={getRowHeight}
              rowHeight={48}
              columnDefs={columnDefs}
              onGridReady={onGridReady}
              loading={loading}
              enableRangeSelection={true}
              sideBar={gridSideBar}
              getRowStyle={(params) => {
                if (params.data.is_deleted === true) {
                  return { background: lighten(0.4, "red") };
                }
              }}
              copyHeadersToClipboard={false}
              onSelectionChanged={onSelectionChanged}
              defaultColDef={defaultColDef}
              detailCellRendererParams={detailCellRendererParams}
              suppressRowDeselection={true}
              rowMultiSelectWithClick={false} // Bu satırı false yapın
              suppressRowClickSelection={true} // Bu satırı ekleyin
              getRowId={(params) => params.data.id} // Eğer verilerinizde unique id'ler varsa
              suppressKeyboardEvent={suppressKeyboardEvent} // Klavye kontrolü için
            />
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              justifyContent: "space-between",
              display: rowData?.length === 0 ? "none" : "flex",

              alignItems: "center",
            }}
          >
            <Grid
              item
              xs={12}
              sx={{
                justifyContent: "center",
                display: rowData?.length === 0 ? "none" : "flex",
                margin: "2% 0 2% 0",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Pagination
                count={totalPage}
                showFirstButton
                showLastButton
                page={currentPage}
                sx={{
                  display: loading ? "none" : "block",
                }}
                onChange={(event, value) => {
                  search(selectedMonth, selectedYear, value, pageSize);
                  setCurrentPage(value);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                  localStorage.set("page", value);
                }}
              />
              <TextField
                select
                value={pageSize}
                size="small"
                sx={{
                  display: rowData?.length === 0 || loading ? "none" : "block",
                }}
                onChange={(e) => {
                  search(selectedMonth, selectedYear, 1, e.target.value);
                  setCurrentPage(1);
                  localStorage.set("page", 1);
                  localStorage.set("pageSize", e.target.value);
                  setPageSize(e.target.value);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
                <MenuItem value={250}>250</MenuItem>
                <MenuItem value={500}>500</MenuItem>
              </TextField>
              <Typography
                sx={{
                  position: "absolute",
                  right: "3%",
                  display: !loading ? "block" : "none",
                }}
              >
                Toplam Kayıt : {totalCount}{" "}
              </Typography>
            </Grid>

            <AddOrRemoveTaxModal
              addOrRemoveTaxModalOpen={addOrRemoveTaxModalOpen}
              setAddOrRemoveTaxModalOpen={setAddOrRemoveTaxModalOpen}
              selectedData={selectedData}
              setSelectedData={setSelectedData}
              handleSave={handleSave}
              selectedMonth={selectedMonth}
              selectedYear={selectedYear}
              types={taxTypesRef.current}
            />
            {/* <RemoveTaxModal
              setRemoveTaxModalOpen={setRemoveTaxModalOpen}
              selectedData={selectedData}
              setSelectedData={setSelectedData}
              search={search}
            /> */}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default ControlsPage;
